import {NaniumObject, RequestType, Type} from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';
import {Facility} from "../../entities/facility.entity";
import {GeoLocationType} from "../../entities/types/geoLocation.type";

export class FacilityQueryPaginatedRequestBody extends NaniumObject<FacilityQueryPaginatedRequestBody> {
	@Type(Number) page: number;
	@Type(Number) pageSize: number;
	@Type(Object) filter?: any;
	@Type(GeoLocationType) userLocation?: GeoLocationType;
	@Type(Boolean) includeAnalytics?: boolean;
}

export class FacilityQueryPaginatedResponse extends NaniumObject<FacilityQueryPaginatedResponse> {
	@Type(Array, Facility) facilities: Facility[];
	@Type(Number) totalCount: number;
	@Type(Number) pageCount: number;
	@Type(Number) pageSize: number;
	@Type(Number) currentPage: number;
}

@RequestType({
	responseType: FacilityQueryPaginatedResponse,
	genericTypes: { TRequestBody: FacilityQueryPaginatedRequestBody },
	scope: 'public',
	skipInterceptors: true
})
export class FacilityQueryPaginatedRequest extends ServiceRequestBase<FacilityQueryPaginatedRequestBody, FacilityQueryPaginatedResponse> {
	static serviceName: string = 'NaniumDemo:facility/queryPaginated';
}
